import { useTranslation } from 'react-i18next';
import SingleDetail from './ContractDetail';
import { fToCurrency, fToLocalNumber } from '@web/utils/src';
import { ContractLineItem, ContractType } from '@/types';

export type PContractLineItem = Pick<
  ContractLineItem,
  | 'deliveredAmount'
  | 'amount'
  | 'erpAmountUnit'
  | 'erpArticleName'
  | 'erpArticleID'
  | 'sellPrice'
  | 'buyPrice'
  | 'erpPriceAmount'
  | 'erpPriceUnit'
  | 'qualityMeasures'
>;

interface Props {
  lineItem: PContractLineItem;
  contractType: ContractType;
  index: number;
}

const LineItem: React.FC<Props> = ({ lineItem, contractType, index }) => {
  const { t } = useTranslation();

  const {
    deliveredAmount = 0,
    amount = 0,
    erpAmountUnit = '',
    erpArticleID = '',
    erpArticleName = '',
    erpPriceAmount = 1,
    erpPriceUnit = '',
    sellPrice = 0,
    buyPrice = 0,
    qualityMeasures = '',
  } = lineItem;

  const formattedDeliveredAmount = `${fToLocalNumber(
    deliveredAmount,
  )} / ${fToLocalNumber(amount)} ${erpAmountUnit}`;

  const formattedSellPrice = `${fToCurrency(sellPrice ?? 0)} / ${
    erpPriceAmount !== 1 ? erpPriceAmount : ''
  }${erpPriceUnit}`;
  const formattedBuyPrice = `${fToCurrency(buyPrice ?? 0)} / ${
    erpPriceAmount !== 1 ? erpPriceAmount : ''
  }${erpPriceUnit}`;

  const priceLabel =
    contractType === ContractType.Purchase
      ? t('contracts.price')
      : t('contracts.price_netto');

  const priceValue =
    contractType === ContractType.Purchase
      ? formattedBuyPrice
      : formattedSellPrice;

  return (
    <div className="border border-secondary-grey rounded-base p-2-0">
      <SingleDetail
        key={erpArticleID}
        label={`${t('contracts.article')} #${index + 1}`}
        value={erpArticleName}
      />
      <SingleDetail
        label={t('contracts.delivered')}
        value={formattedDeliveredAmount}
      />
      <SingleDetail label={priceLabel} value={priceValue} />
      {contractType === ContractType.Purchase && (
        <SingleDetail
          label={t('contracts.quality')}
          value={qualityMeasures ?? ''}
        />
      )}
    </div>
  );
};
export default LineItem;
